import icons from "./svgmarcas.js"
import "./../assets/css/style.css";
import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { TitleMarca } from "./Text";
import { NameMarca } from "./Text";
import { StyledButton } from "./Button";
import { BoxTitle } from "./box";
import { BoxMarca } from "./box";
import { Section } from "./section";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import skechers from "./../img/icon/skechers.png";
import betel from "./../img/icon/betel.png";


function MarcasBlack() {
  const marcasSlick = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 12,
    slidesToScroll: 4,
    responsive: [
      { breakpoint: 480, settings: { slidesToShow: 3.2, slidesToScroll: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 4.2, slidesToScroll: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 6.2, slidesToScroll: 6 } },
      { breakpoint: 1024, settings: { slidesToShow: 8, slidesToScroll: 8 } },
      { breakpoint: 1400, settings: { slidesToShow: 10, slidesToScroll: 10 } }
    ],
  };
  return (
    <Slider {...marcasSlick}>
      <div className="item" >
        <BoxMarca>
          <a className="img-marca icon-puma" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=puma&order=0"></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-umbro" href="https://www.futfanatics.com.br/loja/catalogo.php?loja=311840&categoria=1051&marca=marca_umbro"></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-nicoboco" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=nicoboco"></a>
        </BoxMarca>
      </div>


      <div className="item">
        <BoxMarca>
          <a className="img-marca" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=skechers">
            <img
              src={skechers}
              className="lozad"
            />
          </a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-olympikus" href="https://www.futfanatics.com.br/loja/catalogo.php?loja=311840&categoria=2&marca=marca_olympikus"></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-nb" href="https://www.futfanatics.com.br/treino?loja=311840&categoria=2&marca=marca_new-balance&range="></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-oakley" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=oakley"></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-redley" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=redley"></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-kenner" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=kenner"></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-braziline" href="https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&marca=marca_braziline&range="></a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca" href="https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&marca=marca_betel" style={{ width: 74, height: 74, display: "flex", alignItems: 'center', justifyContent: 'center' }}>
            <img
              src={betel}
              className="lozad"
            />
          </a>
        </BoxMarca>
      </div>

      <div className="item">
        <BoxMarca>
          <a className="img-marca icon-kappa" href="https://www.futfanatics.com.br/loja/busca.php?palavra_busca=kappa"></a>
        </BoxMarca>
      </div>

    </Slider>
  );
}

export default MarcasBlack;
